import { convertToFormattedDateString, DD_MM_YYYY } from '../../../../helpers';

const defaultIntroductions = {
  admissionClosed:
    'Please find enclosed a medication profile prepared for <Patient name> who was discharged from the hospital on <Episode closed date>. This profile lists the medications the patient was taking at the time of discharge and was correct at the time of printing using information sources available. Please note the following summary of medication changes made this admission:',
  default:
    'Please find enclosed a medication profile prepared for <Patient name>. This profile lists the medications the patient was taking at the time of discharge and was correct at the time of printing using information sources available. Please note the following summary of medication changes made this admission:',
};

export const getDefaultIntroductions = (
  patientName: string,
  admissionClosedDateStr?: string,
) => {
  if (!admissionClosedDateStr) {
    return defaultIntroductions.default.replace('<Patient name>', patientName);
  }
  const dateString = convertToFormattedDateString(
    admissionClosedDateStr,
    DD_MM_YYYY,
  );
  return defaultIntroductions.admissionClosed
    .replace('<Patient name>', patientName)
    .replace('<Episode closed date>', dateString);
};
